import _ from 'lodash';
import * as constants from '../constants';

const nms = [ constants.NAMESPACE, 'store', 'actions' ].join('/');
const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').SnackConfig} SnackConfig
 * @typedef {import('vuex').ActionContext<State>} ActionContext
 */

/**
 * @callback SnackAction
 * @param {ActionContext} ctx
 * @param {Error|string|SnackConfig} opts
 * @returns {SnackConfig}
 *
 * @param {import('vuex').Store} store
 * @returns {SnackAction}
 */
export const enqueueSnack = (store) => (ctx, opts) => {
  if (opts instanceof Error) log(opts);
  const config = Object.assign(
    {
      color: 'info',
      timeout: 3000
    },
    opts instanceof Error
      ? { message: opts.message, color: 'error' }
      : typeof opts === 'string' ? { message: opts } : opts
  );
  ctx.commit('setQueue', ctx.state.queue.concat(config));
  return config;
};

/**
 * @callback SnackAction
 * @param {ActionContext} ctx
 * @param {Object} opts
 * @returns {SnackConfig}
 *
 * @param {import('vuex').Store} store
 * @returns {SnackAction}
 */
export const dequeueSnack = (store) => (ctx, opts) => {
  if (opts instanceof Error) log(opts);
  const queue = ctx.state.queue;
  if (!queue.length) return;
  const config = queue[0];
  ctx.commit('setQueue', _.drop(queue));
  return config;
};
